import { SimpleAnswerEnum } from '../../enums/entity.enum';
import { RankEnum } from '../../enums/closedEnd.enum';
import { IClosedEndGPInformation } from '../../interfaces/investment-vehicle/closed-end-gp-information.interface';
import { IUiOption } from '@aksia/infrastructure';

export class ClosedEndGPInformation implements IClosedEndGPInformation {
  closedEndDataFieldsId: number | undefined = undefined;

  //#region Structure

  thirdPartyManagement: SimpleAnswerEnum | undefined = undefined;

  //#endregion

  //#region GP Information

  wmbe: SimpleAnswerEnum | undefined = undefined;

  //#endregion

  //#region Key Considerations

  commingledFundByManager: RankEnum | undefined = undefined;
  commingledFundInSeries: RankEnum | undefined = undefined;

  //#endregion
}
